<template>
    <div>
        <h6 class="titlecolor">{{ label }}</h6>
        <p v-if="readOnly" class="mb-3 mt-1" :class="text ? undefined : 'disabled--text'">
            {{ text || "n/a" }}
        </p>
        <v-textarea v-else v-model="text" auto-grow rows="1" hide-details="auto"
            persistent-placeholder class="mb-3 pt-0 mt-0" outlined dense :loading="loading" :disabled="loading"
            :error="error && error.length > 0" :error-messages="error" clearable @blur="setComment()">
        </v-textarea>
    </div>
</template>


<script>
import http from "@/api/client";

export default {
    name: "CommentField",
    props: {
        machineJob: {
            type: Object,
            required: true
        },
        fieldName: {
            type: String,
            required: true
        },
        label: String,
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    components: {},

    data() {
        return {
            text: "",
            loading: false,
            error: null,
        };
    },

    mounted() {
        this.text = this.originalText;
    },

    methods: {
        async setComment() {
            if (this.text != this.originalText) {
                this.machineJob[this.fieldName] = this.text;
                this.error = null;
                this.loading = true;
                await http()
                    .patch(`api2/partner/jobs/${this.machineJob.Id}/setComment`, { [this.fieldName]: this.text })
                    .catch((error) => {
                        console.error(error);
                        this.error = 'Error saving value.';
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },

    computed: {
        originalText() {
            return this.machineJob[this.fieldName] || "";
        }
    },

    watch: {
        originalText(newVal) {
            this.text = newVal;
        }
    },
};
</script>


<style>
.titlecolor {
    opacity: 0.8;
}

.v-textarea {
    font-size: 0.9em !important;
}
</style>